//
// promise-service.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*global angular: false */

(function() {
    'use strict';

    angular.module('curalate').
        service('PromiseService', ['$q',
            function($q) {
                this.processHttpResponse = function(httpPromise, shouldGetErrorObject) {
                    var deferred = $q.defer(),
                        wrappedPromise,
                        aborted = false;

                    httpPromise.then(function(response) {
                        deferred.resolve(response.data);
                    }, function(response) {
                        if (aborted) {
                            return; // already resolved
                        }

                        if (!response || !response.data) {
                            deferred.reject(response);
                        } else if (!response.data.message || shouldGetErrorObject) {
                            deferred.reject(response.data);
                        } else {
                            deferred.reject(response.data.message);
                        }
                    }, function(progress) {
                        deferred.notify(progress);
                    });

                    wrappedPromise = deferred.promise;
                    wrappedPromise.abort = function () {
                        aborted = true;
                        if (httpPromise.abort) { httpPromise.abort(); }
                        deferred.resolve(undefined);
                    };

                    return wrappedPromise;
                };

                this.requestWithRetries = function(promiseFunc, numRetries, shouldRetryFunc) {
                    var deferred = $q.defer(),
                        aborted = false,
                        outstandingPromise,
                        retryFunc,
                        wrappedPromise;

                    numRetries = Math.max(Math.min(numRetries, 10), 0);

                    retryFunc = function() {
                        if (aborted) {
                            return;
                        }

                        outstandingPromise = promiseFunc();
                        outstandingPromise.then(function(res) {
                            deferred.resolve(res);
                        }).catch(function(err) {
                            numRetries--;
                            if (numRetries > 0 && (!_.isFunction(shouldRetryFunc) || (_.isFunction(shouldRetryFunc) && shouldRetryFunc(err)))) {
                                retryFunc();
                            } else {
                                deferred.reject(err);
                            }
                        });
                    };

                    retryFunc();

                    wrappedPromise = deferred.promise;
                    wrappedPromise.abort = function() {
                        aborted = true;
                        if (outstandingPromise && _.isFunction(outstandingPromise.abort)) {
                            outstandingPromise.abort();
                        }
                        deferred.resolve(undefined);
                    };

                    return wrappedPromise;
                };
            }]);
})();
